<section class="page bank-page">
  <div class="page-heading bank-heading">
    <div>
      <p class="eyebrow">HU-034 · Banco de proyectos</p>
      <h1>Encuentre el proyecto donde puede generar impacto</h1>
      <p>
        Explore proyectos PSA e ICADP validados y seleccione aquel que su
        organización puede implementar.
      </p>
    </div>
    <span class="section-status ready">Rol Implementador</span>
  </div>

  <nav class="bank-view-tabs" aria-label="Modos de exploración del Banco">
    <button
      [class.active]="view === 'territory'"
      (click)="view = 'territory'"
    >
      <i>⌖</i><span>Explorar por territorio</span
      ><small>Mapa, filtros y resultados</small>
    </button>
    <button
      [class.active]="view === 'featured'"
      (click)="view = 'featured'"
    >
      <i>✦</i><span>Proyectos destacados</span
      ><small>Descubra oportunidades</small>
    </button>
  </nav>

  @if (view === "territory") {
    <section class="bank-explorer">
      <aside class="bank-filter-panel">
        <div class="bank-filter-title">
          <h2>Filtrar <span aria-hidden="true">☰</span></h2>
          <button type="button" (click)="clearFilters()">
            Limpiar filtros
          </button>
        </div>
        <label
          >Departamento<select [(ngModel)]="departmentFilter">
            <option value="">Todos</option>
            @for (department of departments; track department) {
              <option [value]="department">{{ department }}</option>
            }
          </select></label
        >
        <label>Municipio<select [(ngModel)]="municipalityFilter"><option value="">Todos</option>@for (municipality of municipalities; track municipality) {<option [value]="municipality">{{ municipality }}</option>}</select></label>
        <fieldset>
          <legend>Ecosistema</legend>
          @for (ecosystem of ecosystems; track ecosystem) {
            <label class="bank-check"
              ><input
                type="checkbox"
                [checked]="ecosystemFilters.includes(ecosystem)"
                (change)="toggleEcosystem(ecosystem)"
              /><span>{{ ecosystem }}</span></label
            >
          }
        </fieldset>
        <fieldset>
          <legend>Tipo de proyecto</legend>
          @for (type of projectTypes; track type) {<label class="bank-check"><input type="checkbox" [checked]="typeFilters.includes(type)" (change)="toggleType(type)"><span>{{ type }}</span></label>}
        </fieldset>
        <fieldset>
          <legend>Estado del proyecto</legend>
          @for (status of projectStatuses; track status) {<label class="bank-check"><input type="checkbox" [checked]="statusFilters.includes(status)" (change)="toggleStatus(status)"><span>{{ status }}</span></label>}
        </fieldset>
        <label class="bank-range">Rango de inversión (COP)<input type="range" min="0" max="5000" step="100" [(ngModel)]="investmentRange"><span><b>$ 0</b><b>$ {{ investmentRange | number:'1.0-0' }} M+</b></span></label>
        <button type="button" class="btn-govco bank-apply-filters">Aplicar filtros</button>
        <button type="button" class="bank-save-search">♧ Guardar búsqueda</button>
        <div class="bank-filter-summary">
          <strong>{{ filtered.length }} proyectos</strong
          ><span>disponibles para implementación</span>
        </div>
      </aside>
      <div class="bank-territory-content">
        <section
          class="bank-map"
          aria-label="Mapa de Colombia con proyectos disponibles"
        >
          <div class="map-water"></div><div class="map-graticule"></div>
          <svg class="colombia-map" viewBox="0 0 300 430" aria-hidden="true">
            <path class="colombia-shadow" d="M149 16l22 8 12 25 20 12 4 30-17 25 11 30-10 28 13 30-17 39-8 44-20 26-2 39-27 34-16-23-26-7-7-31-25-25 3-38-16-28 9-32-12-33 12-30-1-38 22-20 20-2 10-21 27-12 6-30z" />
            <path class="colombia-land" d="M146 11l22 9 11 24 21 13 3 29-17 25 12 30-11 29 14 31-17 38-9 45-19 26-2 39-27 33-15-23-27-6-7-31-25-25 3-38-16-28 9-32-12-34 12-29-1-39 22-20 20-2 10-21 27-12 6-29z" />
            <path class="map-river" d="M147 66c-12 37 19 48 4 84-13 32 18 48-4 82-18 28 5 49-11 84" />
            <path class="map-river secondary" d="M89 153c27 8 34 28 57 38 26 10 29 30 37 50" />
          </svg>
          @for (project of filtered; track project.id; let i = $index) {
            <button
              class="bank-pin"
              [style.left.%]="project.mapX"
              [style.top.%]="project.mapY"
              (click)="selected = project"
              [attr.aria-label]="'Ver proyecto ' + project.name"
            >
              <span>{{ i + 1 }}</span>
            </button>
          }
          <div class="bank-map-key">
            <strong>Ecosistemas</strong><span><i class="ecosystem-andes"></i> Bosques andinos</span><span><i class="ecosystem-humedal"></i> Humedales</span><span><i class="ecosystem-seco"></i> Bosques secos</span>
          </div>
          <div class="bank-map-tools" aria-hidden="true"><button>⌂</button><button>+</button><button>−</button><button>▱</button></div>
        </section>
        <div class="bank-result-heading">
          <div>
            <h2>Resultados del territorio</h2>
            <p>Explore las oportunidades disponibles para implementación.</p>
          </div>
        </div>
        <div class="bank-result-grid">
          @for (project of filtered; track project.id) {
            <article
              class="bank-result-card"
              [class.selected]="isSelected(project.id)"
            >
              <div class="project-landscape" [class]="project.landscape">
                <div>
                  <span class="type-chip">{{ project.type }}</span
                  ><span class="ecosystem-chip">{{
                    project.ecosystem
                  }}</span>
                </div>
              </div>
              <div class="bank-card-content">
                <h3>{{ project.name }}</h3>
                <p class="bank-location">
                  ⌖ {{ project.department }} · {{ project.authority }}
                </p>
                <dl class="bank-metrics">
                  <div>
                    <dt>Familias</dt>
                    <dd>{{ project.potentialFamilies }}</dd>
                  </div>
                  <div>
                    <dt>Predios</dt>
                    <dd>{{ project.potentialProperties || "N/A" }}</dd>
                  </div>
                  <div>
                    <dt>Hectáreas</dt>
                    <dd>
                      {{ project.conservationHectares | number: "1.0-1" }}
                    </dd>
                  </div>
                  <div>
                    <dt>Inversión</dt>
                    <dd>
                      {{
                        project.totalAmount / 1000000 | number: "1.0-0"
                      }}
                      M
                    </dd>
                  </div>
                </dl>
                <div class="bank-card-actions">
                  <a
                    [routerLink]="[
                      '/psa/banco-proyectos/detalle',
                      project.id,
                    ]"
                    >Ver proyecto</a
                  ><button class="btn-govco" type="button" (click)="selected = project">
                    Implementar
                  </button>
                </div>
              </div>
            </article>
          } @empty {
            <div class="validation-empty">
              <strong>No se encontraron proyectos.</strong
              ><span
                >Ajuste los filtros para explorar otras oportunidades.</span
              >
            </div>
          }
        </div>
        <div class="bank-load-more"><button type="button" class="btn-govco secondary">Ver más proyectos</button></div>
      </div>
    </section>
  } @else if (view === "featured") {
    <section class="bank-featured-intro">
      <div>
        <p class="eyebrow">Selección curada</p>
        <h2>Proyectos que transforman el territorio</h2>
        <p>
          Conozca oportunidades priorizadas por su alcance ambiental y
          social.
        </p>
      </div>
      <label
        >Ordenar por<select [(ngModel)]="featuredOrder">
          <option value="impact">Mayor impacto territorial</option>
          <option value="investment">Mayor inversión</option>
          <option value="recent">Validación reciente</option>
        </select></label
      >
    </section>
    <section class="bank-feature-grid">
      @for (project of featured; track project.id) {
        <article class="bank-feature-card">
          <div class="feature-photo" [class]="project.landscape">
            <div class="feature-badges">
              <span>{{ project.type }}</span
              ><span>{{ project.ecosystem }}</span>
            </div>
            <span class="feature-highlight">Proyecto destacado</span>
          </div>
          <div class="feature-body">
            <p class="bank-location">⌖ {{ project.department }}</p>
            <h2>{{ project.name }}</h2>
            <p>{{ project.summary }}</p>
            <dl class="bank-metrics">
              <div>
                <dt>Familias</dt>
                <dd>{{ project.potentialFamilies }}</dd>
              </div>
              <div>
                <dt>Predios</dt>
                <dd>{{ project.potentialProperties || "N/A" }}</dd>
              </div>
              <div>
                <dt>Hectáreas</dt>
                <dd>
                  {{ project.conservationHectares | number: "1.0-1" }}
                </dd>
              </div>
              <div>
                <dt>Inversión</dt>
                <dd>
                  {{
                    project.totalAmount
                      | currency: "COP" : "symbol-narrow" : "1.0-0"
                  }}
                </dd>
              </div>
            </dl>
            <div class="feature-footer">
              <a [routerLink]="['/psa/banco-proyectos/detalle', project.id]"
                >Conocer proyecto</a
              ><button
                class="btn-govco"
                type="button"
                (click)="selected = project"
              >
                Implementar
              </button>
            </div>
          </div>
        </article>
      }
    </section>
    <div class="bank-load-more"><button type="button" class="btn-govco secondary">Ver más proyectos</button></div>
  } @else {
    <section class="bank-compare-page">
      <div class="bank-compare-header">
        <div>
          <p class="eyebrow">Mesa de decisión</p>
          <h2>Compare proyectos y seleccione su oportunidad</h2>
          <p>
            Contraste el alcance de hasta dos proyectos antes de postularse
            como implementador.
          </p>
        </div>
        <button
          type="button"
          class="link-button"
          (click)="selectedIds = []"
        >
          Limpiar comparación
        </button>
      </div>
      @if (comparison.length) {
        <div class="comparison-cards">
          @for (project of comparison; track project.id) {
            <article class="comparison-card">
              <div class="comparison-photo" [class]="project.landscape">
                <span class="type-chip">{{ project.type }}</span
                ><button
                  type="button"
                  (click)="toggleSelection(project.id)"
                  aria-label="Retirar de comparación"
                >
                  ×
                </button>
              </div>
              <h3>{{ project.name }}</h3>
              <p>⌖ {{ project.department }} · {{ project.authority }}</p>
              <a [routerLink]="['/psa/banco-proyectos/detalle', project.id]"
                >Ver proyecto</a
              >
            </article>
          }
          @if (comparison.length === 1) {
            <article class="comparison-empty">
              <span>+</span><strong>Seleccione otro proyecto</strong>
              <p>Vuelva a explorar el Banco para comparar alternativas.</p>
              <button
                type="button"
                class="btn-govco secondary"
                (click)="view = 'territory'"
              >
                Explorar
              </button>
            </article>
          }
        </div>
        <div class="comparison-table">
          <div class="comparison-table-heading">
            <span>Indicador</span>
            @for (project of comparison; track project.id) {
              <strong>{{ project.name }}</strong>
            }
          </div>
          @for (row of comparisonRows; track row.label) {
            <div class="comparison-table-row">
              <span>{{ row.label }}</span>
              @for (project of comparison; track project.id) {
                <strong [class.good]="row.emphasis">{{
                  row.value(project)
                }}</strong>
              }
            </div>
          }
        </div>
        <div class="bank-application">
          <div>
            <span>♧</span>
            <div>
              <h2>¿Listo para asumir la implementación?</h2>
              <p>
                Al postularse, el proyecto quedará asignado a
                <strong>{{ bank.currentImplementer }}</strong> y saldrá del
                Banco de proyectos.
              </p>
            </div>
          </div>
          <button
            type="button"
            class="btn-govco"
            [disabled]="comparison.length !== 1"
            (click)="selected = comparison[0]"
          >
            Postularse como implementador
          </button>
        </div>
      } @else {
        <div class="comparison-empty full">
          <span>⇄</span>
          <h2>Seleccione proyectos para compararlos</h2>
          <p>
            Desde las vistas de territorio o destacados puede agregar hasta
            dos proyectos.
          </p>
          <button
            type="button"
            class="btn-govco"
            (click)="view = 'territory'"
          >
            Explorar proyectos
          </button>
        </div>
      }
    </section>
  }
  <sr-psa-govco-confirm-modal
    [open]="!!selected"
    title="¿Desea asumir la implementación del proyecto?"
    [message]="
      selected
        ? 'Al confirmar, ' +
          selected.name +
          ' saldrá del Banco y quedará en estado En implementación.'
        : ''
    "
    confirmLabel="Sí, asumir proyecto"
    cancelLabel="No, volver"
    (closed)="selected = undefined"
    (confirmed)="assignSelected()"
  />
  <sr-psa-govco-alert-modal
    [open]="!!message"
    title="Proyecto asignado"
    [message]="message"
    variant="success"
    (closed)="message = ''"
  />
</section>
